import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import AttendeesContact from './AttendeesContact';

export class AttendeesModal extends Component {
    render() {

        return (

            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Contact {this.props.attendeeName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <AttendeesContact attendeeName={this.props.attendeeName} emailAddress={this.props.emailAddress} isAuthorized={this.props?.isAuthorized} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={this.props.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }

}
